import { Studies } from './Studies';

export default Studies;



// WEBPACK FOOTER //
// ./src/components/Studies/index.js